import { portalCustomerApiSlice } from "./portalCustomerApiSlice";

export const portalOrderApiSlice = portalCustomerApiSlice.injectEndpoints({
  endpoints: builder => ({
    getPortalOrders: builder.query({
      query: params => ({
        url: "/api/portal/v1/orders/",
        params,
      }),
      providesTags: ["PortalOrders"],
    }),
    getPortalOrderSalesNos: builder.query({
      query: params => ({
        url: "/api/portal/v1/orders/sales_nos/",
        params,
      }),
    }),
    getPortalOrderPoRefs: builder.query({
      query: params => ({
        url: "/api/portal/v1/orders/po_refs/",
        params,
      }),
    }),
    getPortalOrderProductCodes: builder.query({
      query: params => ({
        url: "/api/portal/v1/orders/product_codes/",
        params,
      }),
    }),
    getPortalOrderProductNames: builder.query({
      query: params => ({
        url: "/api/portal/v1/orders/product_names/",
        params,
      }),
    }),
    getPortalOrderStatuses: builder.query({
      query: params => ({
        url: "/api/portal/v1/orders/statuses/",
        params,
      }),
    }),
  }),
});

export const {
  useGetPortalOrdersQuery,
  useGetPortalOrderSalesNosQuery,
  useGetPortalOrderPoRefsQuery,
  useGetPortalOrderProductCodesQuery,
  useGetPortalOrderProductNamesQuery,
  useGetPortalOrderStatusesQuery,
} = portalOrderApiSlice;
